import Swiper from 'swiper/bundle'
import 'youtube-background'
import 'swiper/css/bundle'
import fancybox from '../../resources/js/module/fancybox'
import accordion from '../../resources/js/module/accordion'

$(window).on('load', function () {
    const mainContainer = $('main.content-wrapper'),
        videosSlider = mainContainer.find('.js-video'),
        btnLoadMoreEvent = mainContainer.find('.load-more-events'),
        btnControlDate = mainContainer.find('.tr-events__events-control--left, .tr-events__events-control--right, .tr-events__events-control--today')

    function loadMoreEvent(mainBlock) {
        mainBlock.find('.load-more-events').on('click', function () {

            const items = mainBlock.find('.tr-events__events-item'),
                itemsArr = [],
                thisBtn = $(this),
                dataStart = thisBtn.attr('data-start-day'),
                dataEnd = thisBtn.attr('data-start-end')
            items.each((index, el) => itemsArr.push($(el).attr('data-id-event')))
            $.ajax({
                url: themeVars.ajaxurl,
                data: {
                    action: 'load_more_events_ajax',
                    postsIsShow: itemsArr,
                    dataStart: dataStart,
                    dataEnd: dataEnd,
                    type: 'GET',
                },
                beforeSend: function () {
                    thisBtn.addClass('disabled')

                },
                success: function (response) {
                    if (response) {
                        mainBlock.find('.tr-events__events-container').append(response)
                        thisBtn.removeClass('disabled')
                        if (mainBlock.find('.tr-events__events-item').length >= thisBtn.attr('data-total-events')) {
                            thisBtn.hide()
                        }
                    }
                },
            })
        })
    }

    if (btnControlDate.length >= 1) {
        btnControlDate.on('click', function () {
            let dateStart = mainContainer.find('.tr-events__events-container').attr('data-date-start')
            if ($(this).attr('data-action') === 'today') {
                dateStart = $(this).attr('data-date-start')
            }
            $.ajax({
                url: themeVars.ajaxurl,
                data: {
                    action: 'change_date_events_ajax',
                    dataStart: dateStart,
                    actionChange: $(this).attr('data-action'),
                    type: 'GET',
                },
                beforeSend: function () {
                    // thisBtn.addClass('disabled');
                },
                success: function (response) {
                    if (response) {
                        mainContainer.find('.wrapper-events-block').html(response)
                        const btnLoadMore = mainContainer.find('.load-more-events'),
                            containerBtnLoadMore = mainContainer.find('.block-btn-load-more'),
                            containerEvents = mainContainer.find('.tr-events__events-container'),
                            notFoundBlock = mainContainer.find('.nothing-found')
                        if (containerEvents.attr('data-year-month')) {
                            mainContainer.find('.tr-events__events-date').html(containerEvents.attr('data-year-month'))
                        }
                        mainContainer.find('.tr-events__events-item').length >= btnLoadMore.attr('data-total-events') ? btnLoadMore.hide() : loadMoreEvent(mainContainer)
                        if (btnLoadMore.attr('data-total-events') === '0') {
                            containerEvents.hide()
                            containerBtnLoadMore.hide()
                            notFoundBlock.show()
                        } else {
                            containerEvents.show()
                            containerBtnLoadMore.show()
                            notFoundBlock.hide()
                            accordion(document.querySelector('.accordion'), true)
                        }
                    }
                },
            })
        })
    }

    if (btnLoadMoreEvent.length >= 1) {
        if (mainContainer.find('.tr-events__events-item').length >= btnLoadMoreEvent.attr('data-total-events')) {
            btnLoadMoreEvent.hide()
        }

        loadMoreEvent(mainContainer)
    }


    const sliderInit = function () {
        new Swiper('.news-swiper', {
            slidesPerView: 1,
            spaceBetween: 60,
            watchOverflow: true,
            breakpoints: {
                769: {
                    slidesPerView: 1.25,
                },

                992: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },

                1440: {
                    slidesPerView: 3,
                },

                1800: {
                    slidesPerView: 'auto',
                },
            },
            pagination: {
                el: '.custom-swiper-pagination',
                bulletClass: 'custom-swiper-pagination__bullet',
                clickable: true,
            },
            navigation: {
                nextEl: ".wrapper-slider-navigation-btn--next",
                prevEl: ".wrapper-slider-navigation-btn--prev",
            },
            on: {
                slideChange: function (swip) {
                    if (window.innerWidth <= 768 && swip.el.querySelector('.swiper-pagination-bullet-active')) {
                        swip.el.querySelector('.custom-swiper-pagination').scrollTo({
                            left: swip.el.querySelector('.swiper-pagination-bullet-active').offsetLeft - 140,
                            behavior: 'smooth',
                        })
                    }
                },
            },
        })
    }

    sliderInit()
    fancybox()

    videosSlider.youtube_background({
        mobile: false,
        autoplay: false,
        'fit-box': false,
    })
    let swiperThumbs = new Swiper('.tr-videos__slider-thumb', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        // freeMode: true,
        centeredSlides: true,
    })
    new Swiper('.tr-videos__slider', {
        slidesPerView: 'auto',
        spaceBetween: 28,
        initialSlide: 1,
        loop: false,
        centeredSlides: true,
        watchSlidesProgress: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: true,
        },
        thumbs: {
            swiper: swiperThumbs,
        },
        breakpoints: {
            320: {
                spaceBetween: 20,
            },
            425: {
                spaceBetween: 28,
            },
        },
    })

    accordion(document.querySelector('.accordion'), true)

    setTimeout(() => {
        $('.tr-videos__slider, .tr-videos__slider-thumb').find('iframe').attr('tabindex', -1)
    }, 2000)
})

